import React, { useState, useEffect } from "react";
import moment from "moment";
const FilterSensor = ({ loading, gemiddelde, max, verbruik, accommodatie, index, soort, element }) => {
  const [gemiddeldeState, setGemiddeldeState] = useState(0);
  const [verbruikState, setVerbruikState] = useState(0);
  const [maxState, setMaxState] = useState(0);
  const [showVoorschot, setshowVoorschot] = useState(false);
  useEffect(() => {
    if (loading) {
      setGemiddeldeState(gemiddelde.toFixed(2));
      setVerbruikState(verbruik);
      setMaxState(max.toFixed(2));
      if (element.categotie && element.categotie.voorschot && element.categotie.voorschot > 0) {
        setshowVoorschot(true);
      }
    }
  }, [gemiddelde, max, verbruik, loading]);

  const welkemeter = () => {
    if (soort === "water") {
      return "Kub";
    }
    return "kWh";
  };

  return (
    <div className="container-fluid">
      <div className="row filter-sensor-stats">
        <div className="col-12">
          <div className="row stats-grid">
            <div className="col-12 col-sm-6 col-lg-4 mb-3">
              <div className="stat-card">
                <div className="stat-label">Totaal Verbruik</div>
                <div className="stat-value gemiddelde">
                  {verbruikState} {welkemeter()}
                </div>
              </div>
            </div>
            
            <div className="col-12 col-sm-6 col-lg-4 mb-3">
              <div className="stat-card">
                <div className="stat-label">Gemiddelde (per dag)</div>
                <div className="stat-value gemiddelde">
                  {gemiddeldeState} {welkemeter()}
                </div>
              </div>
            </div>
            
            <div className="col-12 col-sm-6 col-lg-4 mb-3">
              <div className="stat-card">
                <div className="stat-label">Hoogste Piek (per dag)</div>
                <div className="stat-value gemiddelde">
                  {maxState} {welkemeter()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSensor;
